require('./lbErrorModal.scss');

const lbErrorModal = angular.module('app.lbErrorModal', []);

lbErrorModal.component('lbErrorModal', {
  controllerAs: 'vm',
  controller: ['settingsService', 'lbModalService', lbErrorModalCtrl],
  template: require('./lbErrorModal.html'),
});

function lbErrorModalCtrl(settingsService, lbModalService) {
  let vm = this;

  const DEFAULT_MSG = 'Error';
  const DEFAULT_ERROR_DESC = 'Whoops, there has been an error. Please try again.';
  const DEFAULT_ERROR_DESC_INFO = 'We are really sorry about that.';
  const DEFAULT_ERROR_TOKEN = '000000';

  const DEFAULT_REJECTION = {
    status: '',
    statusText: '',
    data: {},
  };

  const rejection = lbModalService.params().rejection || DEFAULT_REJECTION;

  // HTTP 2 does not support statusText whereas 1.1 does, so we mimic it to ensure compatibility
  rejection.statusText = (rejection.statusText || '').toString().trim();
  if (!rejection.statusText) rejection.statusText = (rejection.headers('statustext') || '').toString().trim();

  vm.warnLevel = lbModalService.params().warnLevel || 'warning';
  vm.errorMessage = DEFAULT_MSG;
  vm.errorDesc = DEFAULT_ERROR_DESC;

  const statusMatches = rejection.statusText.toString().match(/.*-(.+)/); // greedy match for a hyphen
  vm.errorToken = (statusMatches ? statusMatches[1] : DEFAULT_ERROR_TOKEN).toString();
  if (vm.errorToken !== DEFAULT_ERROR_TOKEN) vm.instructions = `Your error reference code is ${vm.errorToken}.`;
  vm.errorSupportMessage = settingsService.getErrorContactMsg();

  vm.close = lbModalService.resolve;

  if (vm.warnLevel === 'info') {
    vm.errorDesc = DEFAULT_ERROR_DESC_INFO;

    if (rejection.data.Message) {
      vm.errorMessage = rejection.data.Message;
    }
  }

  if (rejection.data.Instructions) {
    vm.instructions = rejection.data.Instructions;
  }
}

export default lbErrorModal;



// WEBPACK FOOTER //
// ./src/components/lbErrorModal/lbErrorModal.js